import React from "react";
import { makeStyles } from "@material-ui/core";
import BarLoader from "react-spinners/BarLoader";

const useStyles = makeStyles(() => ({
  root: {
    justifyContent: "center",
    display: "flex",
    height: "100%",
    alignItems: "center",
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  wrapperResult: {
    flexDirection: "column",
    maxHeight: "90%",
    overflow: "scroll",
  },
  row: {
    fontSize: 16,
    maxWidth: 580,
  },
  json: {
    overflow: "scroll",
    fontSize: 12,
  },
}));

interface uploadProps {
  result?: string | null;
  imported?: number | null;
  updated?: number | null;
  failed?: number | null;
  errors?: [] | null;
}

interface Props {
  uploadResult: uploadProps;
}

const Uploading: React.FC<Props> = ({
  uploadResult = {
    result: "importing",
    imported: null,
    updated: null,
    failed: null,
    errors: null,
  },
}: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {uploadResult.result === "importing" ? (
        <div className={classes.wrapper}>
          <p>Uploading...</p>
          <BarLoader
            css="display: inherit; border-radius: 4px;"
            color="#0066B3"
            height={10}
            width={200}
          />
        </div>
      ) : (
        <div className={classes.wrapperResult}>
          <div className={classes.row}>Status: {uploadResult.result}</div>
          <div className={classes.row}>Imported: {uploadResult.imported}</div>
          <div className={classes.row}>Updated: {uploadResult.updated}</div>
          <div className={classes.row}>Failed: {uploadResult.failed}</div>
          <div
            className={classes.row}
            style={{ display: uploadResult.failed ? "inline-block" : "none" }}
          >
            <div>Errors:</div>
            <pre className={classes.json}>
              {JSON.stringify(uploadResult.errors, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

export default Uploading;
